import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useTranslation } from '@/i18n';
import { fontSize, lineHeight, unisonColors } from '@/theme';

interface StorageUsageViewProps {
  readonly totalSize: string;
}

export const StorageUsageView = ({ totalSize }: StorageUsageViewProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Text style={styles.label}>
        {t('settings.storage.totalUsed', { defaultValue: 'Total storage used' })}
      </Text>
      <Text style={styles.value}>{totalSize}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 32,
  },
  label: {
    color: unisonColors.textNdPrimary,
    fontSize: fontSize.md,
    lineHeight: lineHeight.md,
    fontWeight: 'bold',
  },
  value: {
    color: unisonColors.textNdPrimary,
    fontSize: fontSize.md,
    lineHeight: lineHeight.md,
    fontWeight: '500',
    textAlign: 'right',
  },
});
